import { AccountRegistrationEffects } from '@store/effects/account-registration/account-registration.effects';
import { FMFEffects } from '@store/effects/fraud-micro-frontend/fmf.effects';

import { MultiInternalTransferEffects } from '../internal-transfers/effects/multi-internal-transfer.effects';
import { AccountTriageEffects } from './account-triage/account-triage.effects';
import { AdobeLaunchEffects } from './adobe-launch/adobe-launch.effects';
import { ClearEffects } from './clear/clear.effects';
import { ClientAccountsEffects } from './client-accounts/client-accounts.effects';
import { ContentEffects } from './content/content.effect';
import { ConvertRegistrationEffects } from './convert-registration/convert-registration.effects';
import { CostBasisEffects } from './cost-basis/cost-basis.effects';
import { DecedentSecurityEffects } from './decedent-security/decedent-security.effects';
import { DocumentsEffects } from './documents/documents.effects';
import { DraftEffects } from './draft/draft.effects';
import { FeatureEffects } from './feature/feature.effects';
import { GiftingIntelledoxRedirectEffects } from './gifting-intelledox-redirect/gifting-intelledox-redirect.effects';
import { GiftingMethodEffects } from './gifting-method/gifting-method.effect';
import { GiftingSummaryEffects } from './gifting-summary/gifting-summary.effect';
import { InternalTransferCalculationsEffects } from './internal-transfer-calculations/internal-transfer-calculations.effect';
import { InternalTransferSummaryEffects } from './internal-transfer-summary/internal-transfer-summary.effect';
import { InvestmentObjectivesEffects } from './investment-objectives/investment-objectives.effects';
import { JointGiftingApprovalEffects } from './joint-gifting-approval/joint-gifting-approval.effect';
import { LoggerEffects } from './logger/logger.effect';
import { MedalliaEffects } from './medallia/medallia.effect';
import { MinorEffects } from './minor/minor.effect';
import { MXMEffects } from './mxm/mxm.effect';
import { InternalTransferOpenAccountEffects } from './open-account/internal-transfer-open-account.effects';
import { OpenAccountEffects } from './open-account/open-account.effects';
import { OpenChoiceEffects } from './open-choice/open-choice.effect';
import { OrgEffects } from './org/org.effects';
import { PersonalDataEffects } from './personal-data/personal-data.effects';
import { RecipientValidationEffects } from './recipient-validation/recipient-validation.effects';
import { RouterEffects } from './router/router.effect';
import { SessionStorageEffects } from './session-storage/session-storage.effects';
import { StartOverEffects } from './start-over/start-over.effects';
import { SubmitEffects } from './submit/submit.effects';
import { SubmitMetricsEffects } from './submit-metrics/submit-metrics.effects';
import { TelemetryEffects } from './telemetry/telemetry.effects';
import { TriageSummaryEffects } from './triage-summary/triage-summary.effect';
import { VerifyDecedentEffects } from './verify-decedent/verify-decedent.effects';
import { ViadocEffects } from './viadoc/viadoc.effects';

export const effects: any[] = [
  AccountRegistrationEffects,
  AccountTriageEffects,
  AdobeLaunchEffects,
  ClearEffects,
  ClientAccountsEffects,
  PersonalDataEffects,
  ContentEffects,
  ConvertRegistrationEffects,
  CostBasisEffects,
  DraftEffects,
  DocumentsEffects,
  GiftingSummaryEffects,
  GiftingMethodEffects,
  InternalTransferOpenAccountEffects,
  InternalTransferCalculationsEffects,
  InternalTransferSummaryEffects,
  MultiInternalTransferEffects,
  JointGiftingApprovalEffects,
  LoggerEffects,
  MedalliaEffects,
  MinorEffects,
  OpenAccountEffects,
  OpenChoiceEffects,
  RouterEffects,
  SessionStorageEffects,
  StartOverEffects,
  SubmitEffects,
  SubmitMetricsEffects,
  TelemetryEffects,
  TriageSummaryEffects,
  OrgEffects,
  VerifyDecedentEffects,
  GiftingIntelledoxRedirectEffects,
  FMFEffects,
  FeatureEffects,
  MXMEffects,
  RecipientValidationEffects,
  InvestmentObjectivesEffects,
  DecedentSecurityEffects,
  ViadocEffects,
];

export * from './account-registration/account-registration.effects';
export * from './account-triage/account-triage.effects';
export * from './adobe-launch/adobe-launch.effects';
export * from './clear/clear.effects';
export * from './client-accounts/client-accounts.effects';
export * from './content/content.effect';
export * from './convert-registration/convert-registration.effects';
export * from './cost-basis/cost-basis.effects';
export * from './documents/documents.effects';
export * from './gifting-intelledox-redirect/gifting-intelledox-redirect.effects';
export * from './gifting-method/gifting-method.effect';
export * from './gifting-summary/gifting-summary.effect';
export * from './internal-transfer-summary/internal-transfer-summary.effect';
export * from './internal-transfer-calculations/internal-transfer-calculations.effect';
export * from './joint-gifting-approval/joint-gifting-approval.effect';
export * from './logger/logger.effect';
export * from './medallia/medallia.effect';
export * from './minor/minor.effect';
export * from './open-account/internal-transfer-open-account.effects';
export * from './open-account/open-account.effects';
export * from './open-choice/open-choice.effect';
export * from './personal-data/personal-data.effects';
export * from './router/router.effect';
export * from './submit-metrics/submit-metrics.effects';
export * from './submit/submit.effects';
export * from './telemetry/telemetry.effects';
export * from './triage-summary/triage-summary.effect';
export * from './verify-decedent/verify-decedent.effects';
export * from './fraud-micro-frontend/fmf.effects';
export * from './draft/draft.effects';
export * from './feature/feature.effects';
export * from './mxm/mxm.effect';
export * from './recipient-validation/recipient-validation.effects';
export * from './org/org.effects';
export * from './decedent-security/decedent-security.effects';
export * from './start-over/start-over.effects';
